export default "__VITE_ASSET__Deyz5ZbJ__";